<template>
  <div class="bg-gray-200 pb-10">
    <div class="lg:container lg:mx-auto flex items-stretch">
      <div class="border-r border-gray-300 w-6/12 pb-4">
        <h2 class="text-blue-600 p-4 mb-10 font-bold border-b border-gray-300">Selected Component</h2>
        <div v-if="part.part_id" class="flex items-center justify-around">
          <ul class="w-6/12">
            <li class="my-2 flex">
              <span class="w-6/12 text-right mr-2"><b>Part No.</b></span>
              <span class="">{{ part.part_number }}</span>
            </li>
            <li v-show="part.depth" class="my-2 flex">
              <span class="w-6/12 text-right mr-2"><b>Overall Depth.</b></span>
              <span class="flex-auto">{{ part.depth_label }}</span>
            </li>
            <!-- <li class="my-2 flex">
                <span class="w-6/12 text-right mr-2"><b>Weight</b></span>
                <span class="flex-auto">{{ part.weight_im }} lb / {{ part.weight }} Kg</span>
              </li> -->
            <li v-show="part.length" class="my-2 flex">
              <span class="w-6/12 text-right mr-2"><b>Length</b></span>
              <span class="flex-auto">{{ part.length }}</span>
            </li>
            <li v-show="part.outlet_size" class="my-2 flex">
              <span class="w-6/12 text-right mr-2"><b>Outlet Size</b></span>
              <span class="flex-auto">{{ part.outlet_size }}</span>
            </li>
          </ul>
          <img :src="part.img_src" />
        </div>
      </div>
      <div v-if="part.related && part.related.length > 0 && run.permissions.update" class="w-2/12">
        <h2 class="text-blue-600 p-4 mb-2 font-bold border-b border-gray-300">Add/Modify Component</h2>
        <div class="flex flex-col pt-2">
          <button
            v-if="part.related"
            class="p-3 border border-gray-400 00 mx-8 hover:bg-blue-800 hover:text-white"
            :class="form.action == actions.Add ? 'bg-blue-800 text-white' : 'bg-gray-300 text-blue-800'"
            @click="addChannel()"
          >
            Add Channel
          </button>
          <button
            class="p-3 border border-gray-400 00 mx-8 hover:bg-blue-800 hover:text-white"
            :class="form.action == actions.Del ? 'bg-blue-800 text-white' : 'bg-gray-300 text-blue-800'"
            @click="delChannel()"
          >
            Remove Channel
          </button>
          <button
            class="p-3 border border-gray-400 00 mx-8 hover:bg-blue-800 hover:text-white"
            :class="form.action == actions.Edit ? 'bg-blue-800 text-white' : 'bg-gray-300 text-blue-800'"
            @click="editGrate()"
          >
            Edit Grate
          </button>
        </div>
      </div>
      <!-- // Add Channel -->
      <div v-if="part && form.action == actions.Add" class="w-3/12 border-l border-gray-300">
        <h2 class="text-blue-600 p-4 mb-2 font-bold border-b border-gray-300">&nbsp;</h2>
        <div class="flex flex-col pt-2 overflow-y-scroll max-h-56">
          <a
            v-for="related in part.related"
            :key="related.id"
            class="p-3 border border-gray-400 text-center mx-8 hover:bg-blue-800 hover:text-white"
            :class="form.channel && form.channel.id == related.id ? 'bg-blue-800 text-white' : 'bg-gray-300 text-blue-800' "
            @click="selectRelatedChannel(related)"
          >
            {{ related.position_label }} - {{ related.length_label }}
          </a>
        </div>
      </div>
      <div v-if="form.action == actions.Add || form.action == actions.Del " class="w-4/12 border-l border-gray-300">
        <h2 class="text-blue-600 p-4 mb-2 font-bold border-b border-gray-300">&nbsp;</h2>
        <form class="flex flex-col pl-6 pt-2" @submit.prevent="update">
          <text-input v-model="form.amount" type="number" :min="1" :max="maxAllowChannels" :error="form.errors.amount" class="w-3/12" />
          <loading-button :loading="form.processing" class="w-3/12 p-3 text-center text-white border border-gray-400 " :class="(form.channel && form.action == actions.Add) || form.action == actions.Del ? 'bg-blue-800': 'cursor-not-allowed bg-gray-800'" tabindex="-1" type="submit">Apply</loading-button>
        </form>
      </div>

      <!-- // Edit Grate -->
      <div v-if="part && form.action == actions.Edit" class="w-3/12 border-l border-gray-300">
        <h2 class="text-blue-600 p-4 mb-2 font-bold border-b border-gray-300">&nbsp;</h2>
        <div class="flex flex-col pt-2 overflow-y-scroll max-h-56">
          <a
            v-for="(g, i) in part.grates"
            :key="i"
            class="flex items-center justify-between p-2 border border-gray-400 hover:bg-blue-800 hover:text-white"
            :class="form.grate && form.grate.cmt == g.cmt ? 'bg-blue-800 text-white' : 'bg-gray-300 text-blue-800' "
            @click="selectGrate(g)"
          >
            <span class="text-sm w-3/4">{{ g.class }} {{ g.material }} <br /> {{ g.design }}</span>
            <img class="" :src="g.img" :alt="g.label" />
          </a>
        </div>
      </div>
      <div v-if="form.action == actions.Edit" class="w-4/12 border-l border-gray-300">
        <h2 class="text-blue-600 p-4 mb-2 font-bold border-b border-gray-300">&nbsp;</h2>
        <form class="flex flex-col pl-6 pt-4" @submit.prevent="update">
          <loading-button :loading="form.processing" class="w-3/12 p-3 text-white border border-gray-400 " :class="form.grate && form.action == actions.Edit ? 'bg-blue-800': 'cursor-not-allowed bg-gray-800'" tabindex="-1" type="submit">Apply</loading-button>
        </form>
      </div>
    </div>
    <!-- container -->
  </div>
  <!-- ! actions -->
</template>

<script>
import groupBy from 'lodash/groupBy'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components:{
    LoadingButton,
    TextInput,
  },
  props: {
    run     : Object,
    part    : Object,
    actions : Object,
  },
  remember: 'form',
  emits: ['update'],
  data() {
    return {
      maxAllowChannels: 1,
      form : this.$inertia.form({
        id     : this.part.id,
        channel: null,
        grate  : null,
        amount : 1,
        action : null,
      }),
    }
  },
  computed: {
    parts() {
      return this.run.sections[this.part.section]
    },
  },
  methods: {
    update() {
      let canUpdate = false

      switch (this.form.action) {
      case this.actions.Add:
        canUpdate = this.form.channel != null
        break
      case this.actions.Del:
        canUpdate = true
        break
      case this.actions.Edit:
        canUpdate = this.form.channel || this.form.grate
        break
      }

      if(canUpdate) {
        this.form
          .transform((data) => ({
            ...data,
            id         : this.part.id,
            channel    : data.channel ? data.channel.id     : null,
            class_id   : data.grate ? data.grate.class_id   : null,
            material_id: data.grate ? data.grate.material_id: null,
            design_id  : data.grate ? data.grate.design_id  : null,
          }))
          .put(`/runs/${this.run.id}/resize`, {
            preserveState: false,
          })
      }
    },
    editGrate() {
      this.maxAllowChannels = 1
      this.form.amount = 1
      this.form.action = this.actions.Edit
    },
    addChannel() {
      this.maxAllowChannels = 1
      this.form.amount = 1
      this.form.action = this.actions.Add
    },
    delChannel() {
      this.maxAllowChannels = 1
      this.form.amount      = 1
      this.form.action      = this.actions.Del
      if (this.part.neutral) {
        let parts = this.parts
        if (this.outlet == 2) {
          if (this.part.section == 1) {
            parts = this.parts.filter(part => part.id >= this.part.id)
          } else {
            parts = this.parts.filter(part => part.id <= this.part.id)
          }
        }

        if (this.outlet == 3) {
          if (this.part.section == 1) {
            parts = this.parts.filter(part => part.id <= this.part.id)
          } else {
            parts = this.parts.filter(part => part.id >= this.part.id)
          }
        }


        let groups = groupBy(parts, part => part.part_id)
        let group = groups[this.part.part_id]
        this.maxAllowChannels = group.length
      }

      // if (this.isFirst(this.part)){
      //   this.maxAllowChannels = this.parts.length - 1
      // }

    },
    selectRelatedChannel(channel) {
      this.maxAllowChannels = 1
      this.form.amount = 1
      this.form.channel = channel

      if (channel.neutral) {
        this.maxAllowChannels = null
      }
    },
    selectGrate(grate) {
      this.form.grate = grate
    },
  },
}

</script>
